module.exports = __webpack_public_path__ + "img/Default-J-6.dbb42d59.svg";